import gql from 'graphql-tag';
import { evaluationFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const addEvaluationMutation = gql`
  mutation AddEvaluation($input: CreateEvaluationInput!) {
    addEvaluation(input: $input) {
      ...AdminSanityDocumentFields
      ...AdminEvaluationFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${evaluationFieldsFragment}
`;